import React, { useState } from 'react';
import ScrapingForm from './ScrapingForm';
import DeviceDataList from './DeviceDataList';
import DirectorList from './DirectorList';
import { HeadersContext } from './headersContext';

const DOBNowConnectPage = () => {
  const [refresh, setRefresh] = useState(false);
  const [headers, setHeaders] = useState({ authToken: "", systemUser: "" });

  // If true, we show the DirectorList on the right; otherwise show the DeviceDataList
  const [showDirectorList, setShowDirectorList] = useState(false);

  const handleScrapeSuccess = () => {
    setRefresh(prev => !prev);
  };

  return (
    <HeadersContext.Provider value={{ headers, setHeaders }}>
      {/* 
        Layout: 
        - Left panel: ScrapingForm 
        - Right panel: either DirectorList OR DeviceDataList
      */}
      <div className="h-screen overflow-hidden flex flex-col md:flex-row">
        
        {/* Left panel (Scraping Form) */}
        <div className="w-full md:w-96 flex-shrink-0 bg-white md:border-r shadow-md p-4">
          <ScrapingForm
            onScrapeSuccess={handleScrapeSuccess}
            // Pass a callback so ScrapingForm can show the DirectorList
            onOpenDirectorList={() => setShowDirectorList(true)}
          />
        </div>
        
        {/* Right panel: shows either DirectorList or DeviceDataList */}
        <div className="w-full flex-1 overflow-y-auto p-4 min-h-0">
          {showDirectorList ? (
            <DirectorList onClose={() => setShowDirectorList(false)} />
          ) : (
            <DeviceDataList refresh={refresh} />
          )}
        </div>

      </div>
    </HeadersContext.Provider>
  );
};

export default DOBNowConnectPage;
